import { WorkflowStepCode } from '@exam-management/graphql';
import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import {
  parseAsInteger,
  parseAsString,
  parseAsStringEnum,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';

export default function useQuestionReviewTaskSearchParams() {
  return useQueryStates({
    code: parseAsStringEnum<WorkflowStepCode | ''>(Object.values(WorkflowStepCode)).withDefault(''),
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    field: parseAsString.withDefault('updatedAt'),
    sort: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
  });
}
